module.exports = __webpack_public_path__ + "img/planta_15.2b4fe12e.png";